import { render, staticRenderFns } from "./secondDetail.vue?vue&type=template&id=0738ceb0&scoped=true"
import script from "./secondDetail.vue?vue&type=script&lang=js"
export * from "./secondDetail.vue?vue&type=script&lang=js"
import style0 from "./secondDetail.vue?vue&type=style&index=0&id=0738ceb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0738ceb0",
  null
  
)

export default component.exports